<script setup>
import { useCongratulationsStore } from '@/store/congratulations'
import { onMounted, ref } from 'vue'
import * as helper from '@/store/helpers'

const congratulationsStore = useCongratulationsStore()

const congratulations = ref([])
const congratulationsCount = ref(0)
const overlay = ref(false)
const fullscreenImage = ref(null)

const openFullscreenImage = (image) => {
    fullscreenImage.value = image
    overlay.value = !overlay.value
}

const detectOverlayClick = (event) => {
    if (event.shadowTarget.tagName !== 'IMG') {
        overlay.value = false
    }
}

onMounted(async () => {
    congratulationsCount.value = await helper.api(
        'GET',
        '/congratulations/count',
        {
            for_admins: false
        }
    )

    await congratulationsStore.getCongratulations(
        0,
        congratulationsCount.value,
        false
    )
    if (congratulationsStore.allCongratulations)
        congratulations.value = congratulationsStore.allCongratulations
})
</script>

<template>
    <swiper-container
        v-if="congratulations.length > 0"
        class="congratulations-slider"
        :pagination="{
            clickable: true
        }"
    >
        <swiper-slide
            v-for="congratulation in congratulations"
            :key="congratulation.id"
            class="congratulations-slide"
        >
            <v-img
                class="congratulations-image"
                :src="congratulation.image"
                height="296px"
                cover
                @click="openFullscreenImage(congratulation.image)"
            />
        </swiper-slide>
    </swiper-container>
    <div
        v-else
        class="congratulations-slider"
    >
        <v-img
            class="congratulations-image"
            src="/img/background.jpeg"
            height="296px"
            cover
        >
            Поздравлений нет
        </v-img>
    </div>
    <v-overlay v-model="overlay">
        <div
            class="overlay-image-container"
            @click="detectOverlayClick"
        >
            <v-icon
                class="overlay-image-close-icon"
                icon="mdi-close"
                color="#fff"
                size="x-large"
            />
            <img
                :src="fullscreenImage"
                alt="Изображение"
            >
        </div>
    </v-overlay>
</template>

<style lang="scss" scoped>
.congratulations-slider .congratulations-slide {
    border-radius: 4px;
}

.congratulations-image {
    color: #fff;
    font-size: 20px;
    text-align: center;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.overlay-image-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    position: relative;

    .overlay-image-close-icon {
        position: absolute;
        top: 0;
        right: 0;
        margin-top: 50px;
        margin-right: 66px;
        cursor: pointer;
    }

    img {
        max-height: 70vh;
        max-width: 70vw;
    }

    @media screen and (max-width: 600px) {
        .overlay-image-close-icon {
            display: none;
        }

        img {
            max-height: 95vh;
            max-width: 95vw;
        }
    }
}
</style>
